export const environment = {
  production: false,
  API_ROOT: 'https://devcustomerapi.penguinpickup.com/customer/',
  MOBILE_CDN_URL: 'https://ppu2devstorageaccount.blob.core.windows.net/',
  CLIENT_ROOT: 'https://dev.app.penguinpickup.com/',
  GOOGLE_MAPS_API_KEY_IOS: 'AIzaSyCoiZtuJ9AkM69-hOufaEv-QhKh0hBKmG0',
  GOOGLE_MAPS_API_KEY_ANDROID: 'AIzaSyC3L7n96G5KK4JU0jqS8jxqbbdZ1nN0Ezo',
  GOOGLE_MAPS_API_KEY_WEB: 'AIzaSyAIvwy158Nlw9zP06lU-91fhsBc1ukLQvg',
  // Maps Styling map ID required for LocationsPage's `colorScheme: FOLLOW_SYSTEM` vector-map dark/light theming
  GOOGLE_MAPS_MAP_ID_WEB: 'c529d8dc22afeced4606d8d4',
  GOOGLE_ANDROID_CERT_SHA1: '0F:D3:02:D5:5B:A2:79:4B:0E:21:C5:4D:6C:15:84:EE:5A:EC:EF:10',
  stripePublishableKey: 'pk_test_51KnjoVBqMdHwrHLezHVXGTmJIwZtdajWrKUAp7EWDLJDdrdWR5FczUpLs9Uqwvj1vt45hS1HpKm4f9qr3Vt3BUb800ykL9HSyG',
  applePayMerchantId: 'merchant.com.penguinpickup.ppumobile.dev',
  msal: {
    clientId: 'd86535c5-d67b-4473-a663-dd9482f6e90d',
    tenantId: 'a59f0d20-2e6b-4c61-810d-8d90c268cebd', // Azure AD > Tenant ID (or 'common' for multi-tenant)
    scopes: ['openid profile offline_access api://ppudev.customer/PPU.Customer.Api'],
    nativeRedirectUri: 'msauth.com.penguinpickup.ppumobile.dev://auth',
    androidNativeRedirectUri: 'msauth.com.penguinpickup.penguincustomer://auth',
  },
};
